import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  list: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsGroupsWithDefaults: ReducersTooling.initialStates.getFetchTypeInitialState(),
  import: ReducersTooling.initialStates.getFetchTypeInitialState(),
  downloadImport: ReducersTooling.initialStates.getFetchTypeInitialState(),
  importFilesList: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculationUnitsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  groupsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  deleteMetricsData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  deleteMetricsMarksData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  exportMetricsData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  save: ReducersTooling.initialStates.getFetchTypeInitialState(),
  delete: ReducersTooling.initialStates.getFetchTypeInitialStateDelete(),
  processingMetricsImportsNotifications: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  refreshVirtualMetricData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  periodId: null
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/metricDataAdmin/initialState.js